import { render, staticRenderFns } from "./kasir.vue?vue&type=template&id=b9a6e480&"
import script from "./kasir.vue?vue&type=script&lang=js&"
export * from "./kasir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports